export var ContentType;
(function (ContentType) {
    ContentType[ContentType["FEATURE_DOCUMENT"] = 0] = "FEATURE_DOCUMENT";
    ContentType[ContentType["FEATURE_FORM"] = 1] = "FEATURE_FORM";
    ContentType[ContentType["MESSAGE"] = 2] = "MESSAGE";
})(ContentType || (ContentType = {}));
//# sourceMappingURL=types.js.map